import request from '@/utils/request'
import { formatParam } from '@/utils/tool'
import {
  RES_ADINFO,
  REQ_TICKETLIST,
  RES_TICKETLIST,
  RES_TICKET_DETAIL
} from './xiecheng-api'

// 轮播广告
export function adInfo (): Promise<RES_ADINFO> {
  return request('/saas/xiecheng/product/adInfo')
}

// 产品列表查询
export function getTicketList (params: REQ_TICKETLIST): Promise<RES_TICKETLIST> {
  return request(`/saas/xiecheng/product/ticketList?${formatParam(params)}`, {
    method: 'POST'
  })
}

// 城市
export function getCity (params?: {
  cityName: string,
  countryName: string
}): any {
  return request(`/saas/xiecheng/product/city?${formatParam(params)}`, {
    method: 'POST'
  })
}

// 门票详情
export function getTicketDetail (params: {
  infoId : string
}): Promise<RES_TICKET_DETAIL> {
  return request(`/saas/xiecheng/product/ticketDetail?${formatParam(params)}`, {
    method: 'POST'
  })
}

// 检查是否串货
export function getCheckTicket (params: {
  infoId: string,
  sdate: string
}): Promise<any> {
  return request(`/saas/xiecheng/product/checkTicket?${formatParam(params)}`, {
    method: 'POST'
  })
}
// 首页景区列表查询
export function getHomeView (params: {
  pageNo: number,
  pageSize: number
}): Promise<RES_TICKETLIST> {
  return request(`/saas/xiecheng/product/ticketViewList?${formatParam(params)}`, {
    method: 'POST'
  })
}
